const StyleSheet = {
  datePicker: {
    width: '200px',
    '& .MuiPickersInputBase-root': {
      border: 0,
      pl: '2px',
    },
    '& .MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer': {
      fontSize: '16px',
      padding: 0,
    },
    '& .MuiInputAdornment-root.MuiInputAdornment-positionEnd': {
      ml: 0,
      '& .MuiIconButton-root': {
        p: 0,
        '& .MuiSvgIcon-root': {
          width: '18px',
          height: '18px',
        },
      },
    },
  },
};

export default StyleSheet;
